/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_DescriptionInputs */

const en_admin_settings_test_description = /** @type {(inputs: Admin_Settings_Test_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run a live request with your current saved config. No orders or data are persisted.`)
};

const zh_admin_settings_test_description = /** @type {(inputs: Admin_Settings_Test_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用当前已保存的配置发起一次真实请求，不会生成订单或写入数据。`)
};

/**
* | output |
* | --- |
* | "Run a live request with your current saved config. No orders or data are persisted." |
*
* @param {Admin_Settings_Test_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_description = /** @type {((inputs?: Admin_Settings_Test_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_test_description(inputs)
	return zh_admin_settings_test_description(inputs)
});
export { admin_settings_test_description as "admin.settings.test.description" }